module.exports = __webpack_public_path__ + "static/media/toc-mockup-font-examples-final.f70ae8a0.jpg";